import { combineReducers } from 'redux';
import { generateConstants } from '../support/utils';
const SUBDOMAIN_AVAILABILITY = generateConstants('SUBDOMAIN_AVAILABILITY');
const SUBDOMAIN_GET = generateConstants('SUBDOMAIN_GET');
const UPDATE_CUSTOM_DOMAIN = generateConstants('UPDATE_CUSTOM_DOMAIN');
const SUBDOMAIN_OPEN = 'SUBDOMAIN_OPEN';
const SUBDOMAIN_CANCEL = 'SUBDOMAIN_CANCEL';
const SUBDOMAIN_INVALID = 'SUBDOMAIN_INVALID';
const SUBDOMAIN_ONCHANGE = 'SUBDOMAIN_ONCHANGE';
const DOMAIN_OPEN = 'DOMAIN_OPEN';
const DOMAIN_CANCEL = 'DOMAIN_CANCEL';
const LINKSETTINGS_LOAD = 'LINKSETTINGS_LOAD';
const CHANGE_IN_ENV = 'CHANGE_IN_ENV';

const defaultState = {
  status: {
    onEdit: false,
    message: null
  },
  availability: {
    isFetching: false,
    response: null,
    didInvalidate: false
  },
  get: {
    isFetching: false,
    response: null,
    didInvalidate: false
  }
};

function subdomain(state, action) {
  if (!state) {
    return defaultState;
  }
  switch (action.type) {
    case LINKSETTINGS_LOAD:
      return Object.assign({}, state, {
        status: {
          onEdit: false,
          message: null
        }
      });
    case SUBDOMAIN_OPEN:
      return Object.assign({}, defaultState, {
        status: {
          onEdit: true
        }
      });
    case SUBDOMAIN_ONCHANGE:
      return Object.assign({}, state, {
        status: {
          onEdit: true,
          newSubdomain: action.data
        }
      });
    case SUBDOMAIN_CANCEL:
      return Object.assign({}, state, {
        status: {
          onEdit: false
        }
      });
    case SUBDOMAIN_INVALID:
      return Object.assign({}, state, {
        status: {
          onEdit: true,
          message: action.data
        }
      });
    case SUBDOMAIN_AVAILABILITY.request:
      return Object.assign({}, state, {
        availability: {
          isFetching: true
        }
      });
    case SUBDOMAIN_AVAILABILITY.response:
      return Object.assign({}, state, {
        availability: {
          isFetching: false,
          response: {
            data: action.data,
            subdomain: action.subdomain
          }
        }
      });
    case SUBDOMAIN_AVAILABILITY.error:
      return Object.assign({}, state, {
        availability: {
          isFetching: false,
          didInvalidate: true,
          response: null
        }
      });
    case SUBDOMAIN_GET.request:
      return Object.assign({}, state, {
        get: {
          isFetching: true
        }
      });
    case SUBDOMAIN_GET.response:
      return Object.assign({}, state, {
        status: {
          onEdit: false
        },
        get: {
          isFetching: false,
          response: action.data || {}
        }
      });
    case SUBDOMAIN_GET.error:
      return Object.assign({}, state, {
        status: {
          onEdit: true,
          message:
            'There was a problem with that subdomain. Please contact support@branch.io or try a different subdomain.'
        },
        get: {
          isFetching: false,
          didInvalidate: true,
          response: action.data || {}
        }
      });
    default:
      return state;
  }
}

const domainDefaultState = {
  status: {
    onEdit: false,
    message: null
  },
  update: {
    isFetching: false,
    response: null,
    didInvalidate: false
  }
};
function domain(state, action) {
  if (!state) {
    return domainDefaultState;
  }
  switch (action.type) {
    case CHANGE_IN_ENV:
      return Object.assign({}, domainDefaultState, {
        status: {
          onEdit: false,
          message: null
        }
      });
    case DOMAIN_OPEN:
      return Object.assign({}, domainDefaultState, {
        status: {
          onEdit: true
        }
      });
    case DOMAIN_CANCEL:
      return Object.assign({}, state, {
        status: {
          onEdit: false
        }
      });
    case UPDATE_CUSTOM_DOMAIN.request:
      return Object.assign({}, state, {
        update: {
          isFetching: true
        }
      });
    case UPDATE_CUSTOM_DOMAIN.response:
      return Object.assign({}, state, {
        status: {
          onEdit: false
        },
        update: {
          isFetching: false,
          response: action.data || {},
          domain: action.domain
        }
      });
    case UPDATE_CUSTOM_DOMAIN.error:
      return Object.assign({}, state, {
        update: {
          isFetching: false,
          didInvalidate: true
        }
      });
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  subdomain,
  domain
});

export default rootReducer;
